import type { OAuthClientCredentials } from '@nextforce/api'
import { getReleaseChannel } from 'app/environment'
import { Platform } from 'react-native'

export type ClientEnvironment =
  | 'development'
  | 'staging'
  | 'production'
  | 'production_internal'
  | 'staging_production_internal'

export function getClientEnvironment(): ClientEnvironment {
  switch (getReleaseChannel()) {
    case 'production':
      return 'production'
    case 'production_internal':
      return 'production_internal'
    case 'staging':
      return 'staging'
    case 'staging_production_internal':
      return 'staging_production_internal'
    default:
      return 'development'
  }
}

export function getClientPlatform(): NonNullable<
  OAuthClientCredentials['platform']
> {
  if (Platform.OS === 'ios') {
    return 'ios'
  }

  if (Platform.OS === 'android') {
    return 'android'
  }

  if (Platform.OS === 'web') {
    return 'web'
  }

  throw new Error(`Unsupported platform: ${Platform.OS}`)
}
